import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout";

Vue.use(Router);

export const constantRoutes = [
  {
    path: "/booking",
    component: Layout,
    redirect: "",
    children: [
      {
        path: "",
        component: () => import("@/views/booking/index"),
        name: "Booking",
        meta: { title: "Booking", hideNavAction: true },
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/signin",
    children: [
      {
        path: "signin",
        component: () => import("@/views/signin/index"),
        name: "SignIn",
        meta: { title: "Please Sign In", hideNavAction: true },
      },
    ],
  },
  {
    path: "/tips",
    component: () => import("@/views/tips/index"),
  },
  {
    path: "/review",
    component: () => import("@/views/review/StoreSwitcher.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/review/index.vue"),
      },
      {
        path: "store",
        component: () => import("@/views/review/aventus.vue"),
      },
    ],
  },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
